export default function initHeaderHideShow() {
  const header = document.querySelector('.headroom');
  const downClass = 'scrolled-down';
  const upClass = 'scrolled-up';
  const pinnedClass = 'is-pinned';
  const animClass = 'is-anim';
  const topOffset = 24;
  let lastScroll = 0;
  let int;

  if (!header) return;

  function updateHeaderClass() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScroll) {
      header.classList.add(downClass);
      header.classList.remove(upClass);
    } else {
      header.classList.add(upClass);
      header.classList.remove(downClass);
    }

    if (currentScroll > topOffset) {
      header.classList.add(pinnedClass);
    } else {
      header.classList.add(downClass);
      header.classList.remove(upClass);
    }

    if (currentScroll <= topOffset) {
      header.classList.remove(pinnedClass);
      header.classList.remove(upClass);
      header.classList.remove(downClass);
      header.classList.remove(animClass);
      clearTimeout(int);
      setTimeout(() => {
        header.classList.remove(animClass);
      }, 150);
    }

    lastScroll = currentScroll;
  }

  updateHeaderClass();
  window.addEventListener('scroll', updateHeaderClass);
}
